/* RepeatDateOfMonthOfYearComponent.js */

"use strict";
const Renderer = require("./RepeatDateOfMonthOfYearRenderer");
const BaseScheduleComponent = require("../../base/BaseScheduleComponent");

class RepeatDateOfMonthOfYearComponent extends BaseScheduleComponent {
    constructor(scheduleComp) {
        super(Renderer, scheduleComp);
    }
    static defaultValue() {
        let now = new Date();
        return {
            type: "domoy",
            tz: Intl.DateTimeFormat().resolvedOptions().timeZone,
            every: 1,
            moy: 1,
            dom: 1,
            time: {
                hour: 12,
                minute: 0,
            },
            start: {
                year: now.getFullYear(),
                month: now.getMonth(),
                date: now.getDate(),
            },
        };
    }
}
module.exports = RepeatDateOfMonthOfYearComponent;
